import services from './services.js';
import NProgress from 'nprogress';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import viewPhoto from 'src/common/js/viewPhoto';
import $http from '$http';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig,
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';


export default {
    mixins: [services],
    props: {
        value: {}
    },
    data() {
        return {
            dialogVisible: false,
            OrderData: {
                UnionRentTemplet: {
                    UnionRentList: []
                },
                ApplyPic: []
            },
            IsShow: false,
            PictureVisible: false,
            dialogImageUrl: '',
            transportList: [],
            PayList: [],
            auditFormData: this.getAuditFormData(), //审核需要提交的数据
            status: [{
                "name": "审核通过",
                "id": "6"
            }, {
                "name": "审核不通过",
                "id": "11"
            }],
            PayWayModes: [{
                "name": "私对公打款",
                "id": "1"
            }, {
                "name": "公对公打款",
                "id": "2"
            }],
            isAuditRemark: false,
            isVoucherMoney: false, //凭证金额
            isReadOnly: false,
            title: '',
            showData: this.getErpConfig(),
            changePic: [],
        }
    },
    computed: {
        isShowClassNum() {
            if (this.OrderData.PackageId != 106 && this.OrderDataProjectType == 2) {
                return true;
            }
            return false;
        },
        isShowJszdByPolicyType() {
            if (this.OrderData.PackageId == 101) {
                return true;
            }
            return false;
        },
        isShowIsFirst() {
            if (this.OrderData.IsFirst > 0) {
                return true;
            }
            return false;
        },
        getAllPrice() {
            return 120;
        },
        isPayWayShow() {
            let payWay = $.trim(this.OrderData.PayWay);
            if (payWay.indexOf("2") > -1) {
                // console.log(payWay)
                return true;
            } else {
                return false;
            }

        },
    },
    methods: {
        dialogClose() {
            this.auditFormData = this.getAuditFormData()
            this.dialogVisible = false;
        },
        getAuditFormData() {
            return cloneDeep({
                "Version": 'V6',
                "OrderId": 0,
                "PayMode": 0,
                "SendMode": 0,
                "Bank": "",
                "BankRecord": "",
                "AuditRemark": "",
                "AmountCollected": "",
                "OrderStatus": null,
                "VoucherMoney": '', //当状态为审核通过时填写凭证金额
                "PreReceiveCode": '', //当状态为审核通过时填写预收单
                "PayWayMode": '',
                "Payer": "",
                "TimeStamp": ""
            });
        },
        getErpConfig() {
            return cloneDeep({
                id: "",
                isReadOnly: false,
                VoucherType: ''
            });
        },
        chooseType(val) {
            // console.log(val)
            if (val == 1 || val == 0) {
                this.auditFormData.OrderStatus = null
            }
            //审核不通过显示审核意见文本

            if (val == 11 || val == 12) {
                this.auditFormData.VoucherMoney = ''
                this.auditFormData.PreReceiveCode = ''
                this.isAuditRemark = true;
                this.isVoucherMoney = false;
            } else if (val == 6) {
                this.auditFormData.AuditRemark = ''
                this.isAuditRemark = false;
                this.isVoucherMoney = true; //凭证金额显示
            } else {
                this.auditFormData.VoucherMoney = ''
                this.auditFormData.PreReceiveCode = ''
                this.isAuditRemark = false;
                this.isVoucherMoney = false;
            }
        },
        show(options) {
            let opts = $.extend({}, this.showData, options);
            this.dialogVisible = true;
            this.isReadOnly = opts.isReadOnly;
            this.showData.VoucherType = opts.VoucherType
            let msg = '凭证'
            if (this.showData.VoucherType == 1) {
                msg = '合同款'
            } else {
                msg = '凭证'
            }
            if (this.isReadOnly) {
                this.title = '订单' + msg + '查看'
            } else {
                this.title = '订单' + msg + '审核'
            }
            this.auditFormData = this.getAuditFormData();
            this.getPay(8);
            this.getPay(9);
            this.getInfo(opts);
        },
        LookPicture(Url) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: Url,
                    id: ""
                }]
            });
        },
        submit() {
            var rules = [{
                name: "审核意见",
                value: this.auditFormData.OrderStatus,
                required: true
            }]
            if (this.isVoucherMoney) {
                rules.push({
                    name: "凭证金额",
                    value: this.auditFormData.VoucherMoney,
                    required: true,
                    more0: true,
                }, {
                    name: "预收单",
                    value: this.auditFormData.PreReceiveCode,
                    required: true
                })
                // 判断打款方式
                if (this.OrderData.PayList[0].PayWay == 7) {
                    rules.push({
                        name: "打款方式",
                        value: this.auditFormData.PayWayMode,
                        required: true,
                    })
                }
            }
            // 打款人
            if (this.auditFormData.PayWayMode == 1) {
                rules.push({
                    name: "打款人",
                    value: this.auditFormData.Payer,
                    required: true,
                })
            }
            if (this.isAuditRemark) {
                rules.push({
                    name: "审核备注",
                    value: this.auditFormData.AuditRemark,
                    required: true
                })
            }
            var flag = util.checkForm({
                ele: this,
                rules: rules
            });
            if (!flag) {
                return;
            }

            this.auditFormData.PayMode = this.OrderData.PayMode;
            this.auditFormData.SendMode = this.OrderData.SendMode;
            //console.log(this.auditFormData)
            // console.log(util.getFormSearchParams(this.auditFormData))
            // 过滤空数据
            var submitData = util.getFormSearchParams(this.auditFormData)

            let tipStatus = '';
            let msg = '凭证'
            if (this.showData.VoucherType == 1) {
                msg = '合同款'
            } else {
                msg = '凭证'
            }
            if (this.auditFormData.OrderStatus == 11) {
                tipStatus = "确认不通过" + msg + "审核吗?"
            } else {
                tipStatus = "确认通过" + msg + "审核吗?"
            }
            this.$confirm(tipStatus, '提示', {
                type: 'warning'
            }).then(() => {
                // VoucherType 2 3 调用同一个接口
                this.auditConfirm2(submitData)
                // if (this.showData.VoucherType == 2) {
                //     this.auditConfirm2(this.auditFormData)
                // } else {
                //     this.auditConfirm3(this.auditFormData)
                // }

            }).catch(() => {});

        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/voucherAudit/components/voucherAuditDialog/vm.js